'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _dec, _dec2, _dec3, _class, _class2, _temp;
// import { Link } from 'react-router';
// import config from '../../config';
// remove this one

// import {isLoaded, load as loadWidgets} from 'redux/modules/widgets';


//React > 16.3
// import { DragDropContext
//   ,Droppable, Draggable
// } from 'react-beautiful-dnd';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _lesson = require('redux/modules/lesson');

var lessonActions = _interopRequireWildcard(_lesson);

var _formik = require('formik');

var _reactBootstrap = require('react-bootstrap');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _components = require('components');

var _reactKatex = require('react-katex');

var _content2 = require('redux/modules/content');

var contentActions = _interopRequireWildcard(_content2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = lessonActions.isLoaded,
    loadContents = lessonActions.loadContents,
    loadLessonById = lessonActions.loadLessonById,
    updateContentOrder = lessonActions.updateContentOrder,
    loadDirectionById = lessonActions.loadDirectionById;
var updateContent = contentActions.updateContent;
// let beautifulDnD;
// let DragDropContext, Droppable, Draggable;

// import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

// fake data generator

var MyWordToContentInnerForm = function MyWordToContentInnerForm(props) {
  var lang = void 0;
  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleLanguageChange = props.handleLanguageChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      lesson_by_id = props.lesson_by_id,
      updateLesson = props.updateLesson;

  return _react2.default.createElement(
    'form',
    { onSubmit: handleSubmit },
    _react2.default.createElement(
      'label',
      { htmlFor: 'title', style: { display: 'block' } },
      'Word'
    ),
    _react2.default.createElement('input', {
      id: 'title',
      placeholder: 'Enter your word',
      type: 'text',
      value: values.title,
      onChange: handleChange,
      onBlur: handleBlur,
      className: errors.title && touched.title ? 'text-input error' : 'text-input'
    }),
    errors.title && touched.title && _react2.default.createElement(
      'div',
      { className: 'input-feedback' },
      errors.title
    ),
    _react2.default.createElement(
      'label',
      { htmlFor: 'lang', style: { display: 'block' } },
      'Language'
    ),
    _react2.default.createElement('input', {
      id: 'lang',
      placeholder: 'Enter your lang',
      type: 'text',
      onChange: handleChange,
      onBlur: handleBlur,
      className: errors.lang && touched.lang ? 'text-input error' : 'text-input'
    }),
    errors.lang && touched.lang && _react2.default.createElement(
      'div',
      { className: 'input-feedback' },
      errors.lang
    ),
    _react2.default.createElement(
      'label',
      { htmlFor: 'type', style: { display: 'block' } },
      'Type: the whole word: 0, ...'
    ),
    _react2.default.createElement('input', {
      id: 'type',
      placeholder: 'Enter your type: 1,2',
      type: 'number',
      onChange: handleChange,
      onBlur: handleBlur,
      className: errors.type && touched.type ? 'text-input error' : 'text-input'
    }),
    errors.type && touched.type && _react2.default.createElement(
      'div',
      { className: 'input-feedback' },
      errors.type
    ),
    _react2.default.createElement(
      'button',
      { type: 'submit', disabled: isSubmitting },
      'Submit'
    )
  );
};

var WordToContentEnhancedForm = (0, _formik.withFormik)({
  mapPropsToValues: function mapPropsToValues() {
    return {
      title: '',
      lang: 'en',
      type: 1
    };
  },
  // validationSchema: Yup.object().shape({
  //   title: Yup.string()
  //     .required('Title is required!'),
  //   title: Yup.string()
  //     .required('Title is required!'),
  // }),
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props,
        setSubmitting = _ref.setSubmitting;

    // props.onChange(values);
    setTimeout(function () {
      props.onChange(values);
      // alert(JSON.stringify(values, null, 2));
      // props.createWordToContent(values.title, props.content.id, values.lang);
      console.log(values);
      console.log(props);
      setSubmitting(false);
    }, 1000);
  },
  displayName: 'BasicForm' // helps with React DevTools
})(MyWordToContentInnerForm);

var getItems = function getItems(count) {
  return (0, _from2.default)({ length: count }, function (v, k) {
    return k;
  }).map(function (k) {
    return {
      id: 'item-' + k,
      content: 'item ' + k
    };
  });
};

var getAllIndexesOf_PCI = function getAllIndexesOf_PCI(arr) {
  //PCI: previousContentId / check
  var indexes = [],
      i;
  console.log("length");
  console.log(arr.length);
  for (i = 0; i < arr.length; i++) {
    console.log(i);
    console.log(arr[i].previousContentId);
    if (arr[i].previousContentId == 0 || arr[i].previousContentId == null) {
      console.log(arr[i].previousContentId);
      indexes.push(i);
    }
  }

  return indexes;
};

var getAllIndexesOf_0Position = function getAllIndexesOf_0Position(arr) {
  //PCI: previousContentId / check that how many '0' position
  var indexes = [],
      i;
  console.log("length");
  console.log(arr.length);
  for (i = 0; i < arr.length; i++) {
    console.log(i);
    console.log(arr[i].position);
    if (arr[i].position == 0 || arr[i].position == null) {
      console.log(arr[i].position);
      indexes.push(i);
    }
  }

  return indexes;
};

// a little function to help us with reordering the result
var reorder = function reorder(list, startIndex, endIndex) {
  //#1: previousContentId = 0 <-- find this one is so easy
  //#2: previousContentId = item[0].id
  //..
  //#n: previousContentId = item[n-1].id

  //Whatif: has no order? like: 2 previousContentId == 0???
  //=> reset all previousContentId to 0?

  //First, check that it has 2 previousContentId = 0 => return original list
  //Then: too many cases


  //
  var length = list.length;
  console.log(length);

  var origin = (0, _from2.default)(list);
  var result = (0, _from2.default)(list);

  //find previousContentId = 0
  // var index = origin.findIndex(x => x.previousContentId==0);
  var indexes = getAllIndexesOf_PCI(list);
  console.log(indexes);
  if (indexes.length != 1) {
    console.log("return origin");
    return origin;
  }
  for (var i = 0; i < origin.length; i++) {
    console.log("origin.length");

    console.log(origin[i]);

    if (i == 0) {
      //put to #1 means: 0
      var _result$splice = result.splice(result.findIndex(function (x) {
        return x.previousContentId == 0;
      }), 1),
          _result$splice2 = (0, _slicedToArray3.default)(_result$splice, 1),
          removed = _result$splice2[0]; //1st param: find the order of item that needs to be removed


      result.splice(i, 0, removed);
    } else {
      var _result$splice3 = result.splice(result.findIndex(function (x) {
        return x.previousContentId == result[i - 1].id;
      }), 1),
          _result$splice4 = (0, _slicedToArray3.default)(_result$splice3, 1),
          _removed = _result$splice4[0]; //1st param: find the order of item that needs to be removed


      result.splice(i, 0, _removed);
    }
  }

  /********/
  //finally: check origin.length vs result length
  //If it's the same, then ok, otherwise: return origin
  if (result.length != origin.length) {
    console.log("something wrong???");
    return origin;
  }
  return result;
};

var grid = 8;

var getItemStyle = function getItemStyle(isDragging, draggableStyle) {
  return (0, _extends3.default)({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: '0 ' + grid + 'px 0 0',

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'grey'

  }, draggableStyle);
};

var getListStyle = function getListStyle(isDraggingOver) {
  return {
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
    display: 'flex',
    padding: grid,
    overflow: 'auto'
  };
};

/*******
Form
********/
// Our inner form component. Will be wrapped with Formik({..})
var MyInnerForm = function MyInnerForm(props) {
  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      lesson_by_id = props.lesson_by_id,
      updateLesson = props.updateLesson;

  return _react2.default.createElement(
    'form',
    { onSubmit: handleSubmit },
    _react2.default.createElement(
      'label',
      { htmlFor: 'title', style: { display: 'block' } },
      'Title'
    ),
    _react2.default.createElement('input', { type: 'checkbox', name: 'active', value: 'active',
      defaultChecked: lesson_by_id.active,

      onChange: function onChange(e) {
        console.log("changed: " + e.target.checked);
        lesson_by_id.active = e.target.checked;
        //Update by calling api here
        updateLesson(lesson_by_id);
      }
    }),
    ' active',
    _react2.default.createElement('input', {
      id: 'title',
      placeholder: 'Enter your title/name',
      type: 'text',
      value: values.title,
      onChange: handleChange,
      onBlur: handleBlur,
      className: errors.title && touched.title ? 'text-input error' : 'text-input'
    }),
    errors.title && touched.title && _react2.default.createElement(
      'div',
      { className: 'input-feedback' },
      errors.title
    ),
    _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'outline',
        onClick: handleReset,
        disabled: !dirty || isSubmitting
      },
      'Reset'
    ),
    _react2.default.createElement(
      'button',
      { type: 'submit', disabled: isSubmitting },
      'Submit'
    )
  );
};

var EnhancedForm = (0, _formik.withFormik)({
  mapPropsToValues: function mapPropsToValues() {
    return { title: '' };
  },
  // validationSchema: Yup.object().shape({
  //   email: Yup.string()
  //     .email('Invalid email address')
  //     .required('Email is required!'),
  // }),
  handleSubmit: function handleSubmit(values, _ref2) {
    var props = _ref2.props,
        setSubmitting = _ref2.setSubmitting;

    props.onChange(values);
    setTimeout(function () {
      alert((0, _stringify2.default)(values, null, 2));
      setSubmitting(false);
    }, 1000);
  },
  displayName: 'BasicForm' // helps with React DevTools
})(MyInnerForm);

var LessonEditor = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref3) {
    var _ref3$store = _ref3.store,
        dispatch = _ref3$store.dispatch,
        getState = _ref3$store.getState,
        id = _ref3.params.id,
        location = _ref3.location;

    // return dispatch(loadContents(id));

    var promises = [];

    var lessonId = id;
    console.log("load lesson by id");
    promises.push(dispatch(loadContents(lessonId)));
    promises.push(dispatch(loadLessonById(lessonId)));

    // return dispatch(loadWidgets());

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    contents_by_lesson: state.lesson.contents_by_lesson,
    lesson_by_id: state.lesson.lesson_by_id
  };
}, (0, _extends3.default)({}, contentActions, lessonActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LessonEditor, _Component);

  function LessonEditor() {
    (0, _classCallCheck3.default)(this, LessonEditor);
    return (0, _possibleConstructorReturn3.default)(this, (LessonEditor.__proto__ || (0, _getPrototypeOf2.default)(LessonEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(LessonEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // { DragDropContext, Droppable, Draggable } = require('react-beautiful-dnd');

    }
  }, {
    key: 'handleTextareaChange',
    value: function handleTextareaChange(event) {
      //if newContent is undefined. 
      this.newContent = {
        // id: 0,
        name: "",
        ctgType: "theory",
        lessonId: this.props.params.id
      };
      this.newContent.data = event.target.value;
      // console.log(this.props.params);
      // console.log(this.newContent);
      // this.forceUpdate();

      // How to translate text here? get the last 5 words? 
      //Default language is vietnamese and english. 
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Home.scss');
      // require the logo image both from client and server
      // const logoImage = require('./logo.png');

      var _props = this.props,
          t = _props.t,
          contents_by_lesson = _props.contents_by_lesson,
          lesson_by_id = _props.lesson_by_id;

      var previousPage = Number(this.props.params.id) > 1 ? Number(this.props.params.id) - 1 : Number(this.props.params.id);

      //nextPage needs to be checked by total page (by contents per page)
      //Load contentCount => page = contentCount/10
      //## shoud write an api to check for future uses of mobile???
      //  API:: /contents/pagesCount(with number contents/page)
      var nextPage = Number(this.props.params.id) + 1;

      //Sort contents_by_lesson by the order
      var contentsForGood = [];
      for (var i in contents_by_lesson) {}

      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'h3',
              null,
              ' ',
              lesson_by_id && lesson_by_id.name,
              ' '
            ),
            ' ',
            _react2.default.createElement(
              _reactBootstrap.Button,
              { onClick: function onClick() {
                  _this2.props.history.push('/lesson/' + lesson_by_id.id);
                } },
              'Preview'
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              { onClick: function onClick() {
                  _this2.props.history.push('/content/' + contents_by_lesson[0].id);
                } },
              'Preview By The Content'
            ),
            contents_by_lesson !== undefined && _react2.default.createElement(_components.SortableComponent, {
              content: reorder(contents_by_lesson),
              onChange: function onChange(data) {
                console.log("list changed");
                console.log(data);

                //Update the order to server
                // promise.all or async.each ?? or a new mysql query
                //Have to remove redundant data
                //Has only id + previousContentId

                //Breaking change: use 'position' instead
                var contentOrderData = []; //What's this?
                for (var i = 0; i < data.length; i++) {
                  console.log(data[i]);
                  contentOrderData.push({
                    id: data[i].id,
                    // previousContentId: data[i].previousContentId,
                    position: i

                  });
                }
                console.log(contentOrderData);

                //Breaking change: update content order by position
                _this2.props.updateContentOrder(contentOrderData);
              }
            }),
            _react2.default.createElement('div', { style: { height: 30 } }),
            lesson_by_id && _react2.default.createElement(
              'p',
              null,
              ' In course: ',
              lesson_by_id.direction && lesson_by_id.direction.name,
              ' '
            ),
            _react2.default.createElement(
              'p',
              null,
              'Change the course'
            ),
            _react2.default.createElement(_components.DirectionSelection, { onChange: function onChange(data) {
                console.log("got cha, direction!!");
                console.log(data);
                _this2.setState({
                  directionValue: data
                });
              } }),
            this.state && this.state.directionValue && _react2.default.createElement(
              _reactBootstrap.Button,
              { onClick: function onClick() {
                  console.log("onclick");
                  console.log(_this2.state.directionValue);

                  //EDIT content, change directionId
                  lesson_by_id.directionsId = _this2.state.directionValue.id;
                  _this2.props.updateLesson(lesson_by_id);
                  // window.location.reload();
                } },
              'Save'
            ),
            contents_by_lesson !== undefined && contents_by_lesson.map(function (item, i) {
              // console.log(item);
              if (item.active === 1) {
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('b', { dangerouslySetInnerHTML: { __html: item.id } }),
                  _react2.default.createElement('b', { dangerouslySetInnerHTML: { __html: item.name } }),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { bsStyle: 'link', onClick: function onClick() {
                        return _this2.props.history.push('/content/' + item.id + '/edit');
                      } },
                    t('content.editContent')
                  )
                );
              }
            })
          ),
          lesson_by_id && _react2.default.createElement(EnhancedForm, this.props),
          _react2.default.createElement(
            'p',
            null,
            'How to organize this `lesson`'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Add a content here.'
          ),
          _react2.default.createElement('textarea', {
            // value={(this.newContent && this.newContent.data) ? this.newContent.data : ""}
            onChange: this.handleTextareaChange.bind(this) }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Translated phrases'
            )
          ),
          _react2.default.createElement(WordToContentEnhancedForm, (0, _extends3.default)({}, this.props, { onChange: function onChange(data) {
              console.log('data');
              console.log(data);
              // console.log(this.props);
              createWordToContent(data.title, content.id, data.type, data.lang);
            } })),
          _react2.default.createElement(
            _reactBootstrap.Button,
            { onClick: function onClick() {
                //create a content => then update with lesson id (apis are already existed).
                //(1): get content 
                console.log(_this2.newContent);
                _this2.newContent.position = contents_by_lesson.length;
                _this2.props.updateContent(_this2.newContent).then(function () {
                  console.log("done?");
                  var promises = [];

                  var lessonId = _this2.props.params.id;
                  promises.push(_this2.props.loadContents(lessonId));
                  promises.push(_this2.props.loadLessonById(lessonId));
                  _promise2.default.all(promises).then(function () {
                    console.log("eee");
                    _this2.newContent = {};
                    _this2.forceUpdate();
                  });
                  //reload page here. 
                });
                //what to do here. 

                //get contents't length 

                // newContent's position equals to `length`

              } },
            'Create a new'
          ),
          _react2.default.createElement(
            'p',
            null,
            '--------'
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            null,
            contents_by_lesson !== undefined && contents_by_lesson.map(function (_content) {
              return _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _content.data
                ),
                ' ',
                _react2.default.createElement(
                  _reactBootstrap.Button,
                  { onClick: function onClick() {
                      console.log("remove this content.");
                      console.log(_content.id);
                      //what if i remove the-not-the-last-one... ? 
                      //then what to do... 

                      _this2.props.removeContent(_content.id).then(function () {
                        var promises = [];
                        var lessonId = _this2.props.params.id;
                        promises.push(_this2.props.loadContents(lessonId));
                        promises.push(_this2.props.loadLessonById(lessonId));
                        _promise2.default.all(promises).then(function () {
                          console.log("eee");
                          _this2.newContent = {};
                          _this2.forceUpdate();
                        });
                      });
                    } },
                  'Remove'
                ),
                ' ',
                _react2.default.createElement(
                  _reactBootstrap.Button,
                  { bsStyle: 'link', onClick: function onClick() {
                      return _this2.props.history.push('/content/' + _content.id + '/edit');
                    } },
                  t('content.edit')
                )
              );
            })
          ),
          _react2.default.createElement(
            'p',
            null,
            'Create a field that marks the lesson is the new type => show the contents continously.. => url should change BTW'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Create the content inside this page... think about it.'
          )
        )
      );
    }
  }]);
  return LessonEditor;
}(_react.Component), _class2.propTypes = {
  t: _react.PropTypes.func,
  contents_by_lesson: _react.PropTypes.array
  // newContent: PropTypes.object,
}, _temp)) || _class) || _class) || _class);
exports.default = LessonEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/LessonEditor.js
// module id = 1523
// module chunks = 0